module.exports = __webpack_public_path__ + "img/153-bonaire.26a6a0ad.svg";